import { Component } from 'react';

export default class Home extends Component {

    render() {

        return (
            <div className='Home'>
                <div className='Home_Container'>
                    <div className='Home_CompanyName'>Sharpers</div>
                    <div className='Home_AnimationTextBlock'>
                        <div className='Home_AnimationText'>Better</div>
                        <div className='Home_Text'>Development</div>
                    </div>
                    <div className='Home_Desc'>
                        The world is changing faster than even before, Shapers are threatened as technology discripts and software. Yet those embrace chnage are thriving, building bigger, better ,faster and stronger production development than ever before, we help you build on your top past and prepare future.
                    </div>
                </div>
                <div className='Home_Arrow'>
                    <div className="arrows">
                      <span class="m_scroll_arrows unu"></span>
                      <span class="m_scroll_arrows doi"></span>
                      <span class="m_scroll_arrows trei"></span>
                    </div>
                </div>
            </div>
        );
    }
}